<form class="form-vertical" id="editdoctypeform" data-hook="editdoctypeform">
  <div class="row">
    <div class="form-group col-md-12">
      <label for="dtid">ID</label>
      <input type="text" ng-model="vm.doctype._id" class="form-control" id="dtid" tabindex="-1" readonly
             placeholder="ID">
    </div>
  </div>

  <div class="row">
    <div class="form-group col-md-12">
      <label for="name">Name</label>
      <input type="text" ng-model="vm.doctype.name" class="form-control" id="name" tabindex="1"
             placeholder="Name">
    </div>
  </div>

  <div class="row">
    <div class="form-group col-md-12">
      <label for="filename">Filename</label>
      <input type="text" ng-model="vm.doctype.filename" class="form-control" id="filename" tabindex="2"
             placeholder="Filename">
    </div>
  </div>

  <form class="form-vertical" id="editsvform">
    <div class="row">
      <div class="form-group col-md-12">
        <label for="xslt">Stylesheet (Filename, ohne Pfad)</label>
        <input type="text" ng-model="vm.doctype.stylesheet" class="form-control" id="xslt" tabindex="3"
               placeholder="XSLT Stylesheet Dateiname">
      </div>
    </div>

    <div class="row">
      <div class="form-group col-md-12">
        <label for="print">Drucker  (Derzeit gewählt: {{vm.doctype.printer}} )</label>
        <select ng-model="vm.doctype.printer" class="form-control" id="print"  tabindex="3">
          <option value="{{p.printername}}" ng-repeat="p in vm.allprinters">{{p.printername}}, {{p.description}}</option>
        </select>
      </div>
    </div>
  
  <div class=" row">
    <div class="col-xs-12">
      <div class="form-group">
        <button class="btn btn-success" type="button" tabindex="9" ng-click="vm.save()">Speichern</button>
        <button class="btn btn-danger" type="button" tabindex="10" ng-click="vm.cancel()">Abbrechen</button>
      </div>
    </div>
  </div>
</form>